import { render } from "./AdminList.vue?vue&type=template&id=157dcf5b&scoped=true"
import script from "./AdminList.vue?vue&type=script&lang=js"
export * from "./AdminList.vue?vue&type=script&lang=js"

import "./AdminList.vue?vue&type=style&index=0&id=157dcf5b&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157dcf5b"]])

export default __exports__